import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionIconProps extends ComponentProps<'span'> {}

export function SidepanelSectionIcon({ className, children, ...props }: SidepanelSectionIconProps) {
  return (
    // The 20px slot is what lines the header up with the rows beneath it: every
    // section body — start-note row, meeting cell, history row — puts a `size-5`
    // icon box at 24px from the panel edge and its text at 52px. Sizing the glyph
    // alone left the header 4px out on the icon and 11px out on the label.
    <span
      aria-hidden="true"
      className={twMerge(
        'text-foreground-secondary flex size-5 shrink-0 items-center justify-center',
        'group-hover/title:text-foreground motion-reduce:transition-none [&>svg]:size-4',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}
